import { createAction, props } from '@ngrx/store';

import { ApiError } from '@error/models/api-error';
import { UserBaseInfo } from '@users/models/user-base-info';

export const loadCustomers = createAction('[Users] Load Customers');
export const loadCustomersSuccessful = createAction('[Users] Load Customers Successful', props<{ customers: UserBaseInfo[] }>());
export const loadCustomersFailed = createAction('[Users] Load Customers Failed', (error: ApiError) => error);